import {
  GET_LIST_DANHSACHNHANVIEN,
  GET_LIST_DANHSACHNHANVIEN_SUCCESS,
  GET_LIST_DANHSACHNHANVIEN_FAILURE,
} from "./actionTypes";

export const getListDanhSachNhanVien = (dataSearch) => ({
  type: GET_LIST_DANHSACHNHANVIEN,
  dataSearch,
});

export const getListDanhSachNhanVienSuccess = (data) => ({
  type: GET_LIST_DANHSACHNHANVIEN_SUCCESS,
  payload: data,
});

export const getListDanhSachNhanVienFailure = () => ({
  type: GET_LIST_DANHSACHNHANVIEN_FAILURE,
});
